import axios from "axios";
import store from "./../store/index.js";
import router from "./../router";

const baseURL = import.meta.env.VITE_APP_BASE_URL;

async function request(method, endpoint, body, callbackOrConfig, legacyConfig) {
  const callback = typeof callbackOrConfig === "function"
    ? callbackOrConfig
    : null;
  const config = callback
    ? legacyConfig
    : callbackOrConfig ?? legacyConfig;

  if (!navigator.onLine) {
    if (callback) return;
    throw new Error("No internet connection.");
  }

  const axiosInstance = apiRequest.makeCustomAxiosInstance();
  let response;

  try {
    if (method === "get" || method === "delete") {
      response = await axiosInstance[method](endpoint, config || {});
    } else {
      response = await axiosInstance[method](endpoint, body, config || {});
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      apiRequest.unauthorizedToken();
      if (callback) return;
    } else if (callback) {
      callback(error);
      return error;
    }

    throw error;
  }

  if (callback) callback(response);
  return response;
}

const apiRequest = {
  /**
   *
   * make post api request
   * @param {String} endpoint
   * @param {Object} body
   * @param {Function} success called after api response/error
   * @param {Object} config custom configurations for axios
   * @return void
   */
  post: (endpoint, body, successOrConfig, config = null) =>
    request("post", endpoint, body, successOrConfig, config),

  /**
   * make get api request
   * @param {String} endpoint
   * @param {Object} body
   * @param {Function} success called after api response/error
   * @param {Object} config custom configurations for axios
   * @return void
   */
  get: (endpoint, successOrConfig, config = null) =>
    request("get", endpoint, undefined, successOrConfig, config),

  /**
   * make custom axios instance
   * @param {Object} config The config object provided by user.
   * @return axios custom instance
   */
  makeCustomAxiosInstance: () => {
    let token = localStorage.getItem("token");
    //custom configuration for axios
    let axiosConfig = {
      baseURL,
    };
    //if token is present
    if (token) {
      axiosConfig.headers = {
        token: JSON.parse(token),
      };
    }
    //create and return axios instance with custom configurations
    return axios.create(axiosConfig);
  },


/**
 * PUT request — used to save odometer.
 * Returns a Promise containing the Axios response.
 */
put: (endpoint, body, config = null) =>
  request("put", endpoint, body, config),

/**
 * DELETE request — used to remove optional photos.
 * Returns a Promise containing the Axios response.
 */
delete: (endpoint, config = null) =>
  request("delete", endpoint, undefined, config),


  /**
   * user is unauthorized, go to login page
   *
   * @return void
   */
  unauthorizedToken: () => {
    //clear all storages
    store.commit("logout");
    //resolve route
    let login = router.resolve({
      name: "login",
      params: "/",
    });
    //move to login page
    window.location.assign(login.href);
  },
};
export default apiRequest;
